import React from 'react';
import { AnalyzeModal } from './AnalyzeIntentModal';

/**
 * AnalyzeAiResponseModal — wrapper para análise de instruções do nó ai_response.
 *
 * Props:
 *  - isOpen, onClose, onApply, analysis, loading, error, onRetry — ver AnalyzeModal
 *  - currentInstructions: string — instruções atuais (exibidas no diff)
 */
const AnalyzeAiResponseModal = ({ currentInstructions, ...rest }) => (
  <AnalyzeModal
    {...rest}
    title="Análise das instruções da IA"
    currentValue={currentInstructions}
    currentValueLabel="Instruções atuais"
    improvedValueLabel="Instruções sugeridas"
    improvedField="improved_instructions"
    showOverlapWarnings={false}
    showExamples={false}
  />
);

export default AnalyzeAiResponseModal;
